import { Logboek } from "./Logboek";

interface Props {
  onBack: () => void;
}

export function BP26ArchiefView({ onBack }: Props) {
  return (
    <div className="min-h-full safe-top safe-bottom flex flex-col">
      <header className="px-5 pt-6 pb-4 flex items-center justify-between">
        <button
          onClick={onBack}
          aria-label="Terug naar overzicht"
          className="inline-flex items-center gap-2 text-zinc-400 hover:text-zinc-200 text-2xs uppercase font-semibold"
          style={{ letterSpacing: "0.18em" }}
        >
          <span aria-hidden="true">←</span>
          Overzicht
        </button>
        <div className="flex items-center gap-2.5">
          <span className="w-1 h-5 bg-zinc-600 rounded-full" />
          <span
            className="text-zinc-500 text-[10px] font-semibold uppercase"
            style={{ letterSpacing: "0.2em" }}
          >
            BP26 · ARCHIEF
          </span>
        </div>
      </header>

      <main
        className="flex-1 px-5 pb-10 max-w-2xl w-full mx-auto"
        aria-label="BP26 — Bevrijdingspop Haarlem 2026 · archief"
      >
        <h1
          className="text-zinc-200 text-lg font-semibold tracking-tight mb-1"
          style={{ letterSpacing: "-0.015em" }}
        >
          BP26 — Bevrijdingspop Haarlem 2026
        </h1>
        <p className="text-zinc-600 text-sm mb-6">Archief · 5 mei 2026</p>

        <Logboek />
      </main>
    </div>
  );
}
